export default function statusFilter(tickets, status = 'completed') {
  if (Array.isArray(tickets)) {
    return tickets.filter((t) => t.status === status);
  } else {
    return [];
  }
}
